export default {
	success: 'success',
	error: 'error',
	warning: 'warning',
	info: 'info',
	isValid: function(type) {
		return type === this.success || type === this.error || type === this.warning || type === this.info;
	}
};
